const actionsToPathMap = {
  'go-to:rules': 'groups',
  'go-to:xpacks': 'xpacks',
  'go-to:intents': 'intents',
  'go-to:contexts': 'contexts',
  'go-to:entities': 'entities',
  'go-to:files': 'resources',
  'go-to:test-sets': 'test-sets',
  'go-to:flow': 'flow',
  'go-to:dictionaries': 'dictionaries',
};

const getPath = action => actionsToPathMap[action];

export default getPath;
